import { useEffect, useState } from "react"

type fnSignature = (() => any) | (() => Promise<any>)

function isPromise(obj: any): obj is Promise<any> {
    return typeof obj === "object" && "then" in obj;
}

export const useEffectAsync = (fn: fnSignature, deps: any[] = []) => {
    const [error, setError] = useState<any>(null);
    useEffect(() => {
        let cleanup = () => { };
        try {
            const fnResult = fn();
            if (fnResult) {
                if (isPromise(fnResult)) {
                    fnResult.then(cb => {
                        cleanup = cb;
                    }).catch(err => {
                        setError(err);
                    });
                } else {
                    if (typeof fnResult === "function")
                        cleanup = fnResult;
                }
            }
        } catch (e) {
            setError(e);
        }

        return cleanup;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps)
    return {
        error
    }
}


export function delay(time: number) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  export function getMobileOperatingSystem() {
    const navigatorAgent = navigator.userAgent
    if (navigatorAgent.indexOf("iPhone") > -1 || navigatorAgent.indexOf("iPod") > -1 || navigatorAgent.indexOf("iPad") > -1) {
        return "iOS"
    } else if (/Android/.test(navigatorAgent)) {
        return "Android"
    } else if (/Windows Phone/.test(navigatorAgent)) {
        return "Windows Phone"
    }
    return ''
}